import overSpeedImage from "../../../images/graphs/overspeed.png";
import maxspeedImage from "../../../images/graphs/maxspeed.jpeg";
import runtimeImage from "../../../images/graphs/runtime.png";
import routeDeviationImage from "../../../images/graphs/routedeviations.png";
import averageSpeedImage from "../../../images/graphs/averageSpeed.png";
import tripsImage from "../../../images/graphs/trips.png";
import vehicleWiseTripsImage from "../../../images/graphs/vehicleWiseTrips.png";
import vehcileHaltImage from "../../../images/graphs/vehicleHalts.png";
import vehicleHaltsDuration from "../../../images/graphs/vehcileHaltsDuration.png";
import tripsByTimeImage from "../../../images/graphs/tripsByTimeofDay.png";
import stopsVisitedImage from "../../../images/graphs/stopsVisited.png";
import tripsPerRouteImage from "../../../images/graphs/routeWiseTrips.png";
import distanceCoveredImage from "../../../images/graphs/distanceCovered.png";
// import routeSpecifiicTripsImage from "../../../images/graphs/routeSpecificTrips.png";
import overspeedTimelineImage from "../../../images/graphs/overspeedTimeline.png"
import tripGanttTimelineImage from "../../../images/graphs/tripDurationTimeline.png"
import deadHaltCountImage from "../../../images/graphs/deadHalts.png"
import inactiveHaltCountImage from "../../../images/graphs/inactiveHalts.png"
import deadHaltDurationImage from "../../../images/graphs/deadHaltsDuration.png"
import inactiveHaltDurationImage from "../../../images/graphs/inactiveHaltsDuration.png"
import tripStartsImage from "../../../images/graphs/tripstarts.png"
import tripEndsImage from "../../../images/graphs/tripends.png"
import tripStartEndImage from "../../../images/graphs/tripstartend.png"
// import tripTimelineImage from "../../../images/graphs/tripTimeline.png"
// Chart configuration template
export const CUSTOM_CHART_CONFIGS = [
  {
    id: "overspeed_incidents",
    title: "Overspeed Incidents",
    reportType: "overspeed",
    category: "vehicles",
    chartType: "barGraph",
    color: "#EE3B2B",
    img: overSpeedImage,
    width: 320,
    height: 280,
  },
  {
    id: "maximum_speed",
    title: "Maximum Speed",
    reportType: "overspeed",
    category: "vehicles",
    chartType: "barGraph",
    color: "#183059",
    img: maxspeedImage,
    width: 320,
    height: 280,
  },
  {
    id: "total_runtime",
    title: "Total Runtime ",
    reportType: "runtime",
    category: "vehicles",
    chartType: "barGraph",
    color: "#008C23",
    img: runtimeImage,
    width: 320,
    height: 280,
  },
  {
    id: "total_route_deviation",
    title: "Route Deviations",
    reportType: "activity",
    category: "vehicles",
    chartType: "pieChart",
    color: "#2E86C1",
    img: routeDeviationImage,
    width: 320,
    height: 280,
  },
  {
    id: "average_speed",
    title: "Overall Average Speed",
    reportType: "activity",
    category: "vehicles",
    chartType: "barGraph",
    color: "#183059",
    img: averageSpeedImage,
    width: 320,
    height: 280,
  },
  {
    id: "trip_status",
    title: "Trips ",
    reportType: "trip",
    category: "vehicles",
    chartType: "pieChart",
    img: tripsImage,
    color: "#3498DB",
    width: 320,
    height: 280,
  },
  {
    id: "total_trips",
    title: "Vehicle Wise Trips",
    reportType: "trip",
    category: "vehicles",
    chartType: "barGraph",
    img: vehicleWiseTripsImage,
    color: "#1ABC9C",
    width: 320,
    height: 280,
  },
  {
    id: "total_halt",
    title: "Vehicle Halts",
    reportType: "halt",
    category: "vehicles",
    chartType: "barGraph",
    img: vehcileHaltImage,
    color: "#16A085",
    width: 320,
    height: 280,
  },
  {
    id: "halt_duration",
    title: "Vehicle Halts Duration",
    reportType: "halt",
    category: "vehicles",
    chartType: "barGraph",
    img: vehicleHaltsDuration,
    color: "#27AE60",
    width: 320,
    height: 280,
  },
  {
    id: "trips_by_time_of_day",
    title: "Trips by Time of Day",
    reportType: "trip",
    category: "vehicles",
    chartType: "lineGraph",
    img: tripsByTimeImage,
    color: "#2980B9",
    width: 320,
    height: 280,
  },
  {
    id: "stops_visited",
    title: "Stops Visited",
    reportType: "runtime",
    category: "vehicles",
    chartType: "barGraph",
    img: stopsVisitedImage,
    color: "#8E44AD",
    width: 320,
    height: 280,
  },
  {
    id: "distance_covered",
    title: "Distance Covered",
    reportType: "runtime",
    category: "vehicles",
    chartType: "barGraph",
    img: distanceCoveredImage,
    color: "#17A2B8",
    width: 320,
    height: 280,
  },
  {
    id: "trips_per_route",
    title: "Route Wise Trips",
    reportType: "trip",
    category: "vehicles",
    chartType: "barGraph",
    img: tripsPerRouteImage,
    color: "#9B59B6",
    width: 320,
    height: 280,
  },
  {
    id: "route_specific_trips",
    title: "Route Specific Trips by Vehicle",
    reportType: "trip",
    category: "vehicles",
    img: overSpeedImage,
    chartType: "barGraph",
    color: "#E74C3C",
    width: 320,
    height: 280,
    isDynamic: true, // Flag to indicate this is dynamically generated
  },
  {
    id: "overspeed_timeline",
    title: "Overspeed Timeline",
    reportType: "overspeed",
    category: "vehicles",
    chartType: "multiLineGraph",
    img: overspeedTimelineImage,
    color: "#EE3B2B",
    width: 1000,
    height: 350,
  },
  {
    id: "dead_halt_count",
    title: "Dead Halts",
    reportType: "halt",
    category: "vehicles",
    chartType: "barGraph",
    img: deadHaltCountImage,
    color: "#ee3b2b",
    width: 320,
    height: 280,
  },
  {
    id: "inactive_halt_count",
    title: "Inactive Halts",
    reportType: "halt",
    category: "vehicles",
    chartType: "barGraph",
    img: inactiveHaltCountImage,
    color: "#f9e719",
    width: 320,
    height: 280,
  },
  {
    id: "dead_halt_duration",
    title: "Dead Halts Duration",
    reportType: "halt",
    category: "vehicles",
    chartType: "barGraph",
    img: deadHaltDurationImage,
    color: "#ee3b2b",
    width: 320,
    height: 280,
  },
  {
    id: "inactive_halt_duration",
    title: "Inactive Halts Duration",
    reportType: "halt",
    category: "vehicles",
    chartType: "barGraph",
    img: inactiveHaltDurationImage,
    color: "#f9e719",
    width: 320,
    height: 280,
  },
  // {
  //   id: "trip_timeline",
  //   title: "Trips Timeline - Trips Over Time",
  //   reportType: "trip",
  //   category: "vehicles",
  //   chartType: "multiLineGraph",
  //   color: "#2980B9",
  //   width: 1000,
  //   height: 350,
  // },
  {
    id: "trip_gantt_timeline",
    title: "Trips Duration Timeline",
    reportType: "trip",
    category: "vehicles",
    chartType: "horizontalBarTimeline",
    img: tripGanttTimelineImage,
    color: "#16A085",
    width: 1000,
    height: 350,
  },
  {
    id: "trip_starts",
    title: "Trip Starts",
    reportType: "trip",
    category: "vehicles",
    chartType: "pieChart",
    img: tripStartsImage,
    color: "#1ABC9C",
    width: 320,
    height: 280,
  },
  {
    id: "trip_ends",
    title: "Trip Ends",
    reportType: "trip",
    category: "vehicles",
    chartType: "pieChart",
    img: tripEndsImage,
    color: "#1ABC9C",
    width: 320,
    height: 280,
  },
  {
    id: "trip_start_end",
    title: "Trips Start and End",
    reportType: "trip",
    category: "vehicles",
    chartType: "barGraph",
    img: tripStartEndImage,
    color: "#1ABC9C",
    width: 320,
    height: 280,
  }
];